export default [
  {
    title: 'What the Campaign is',
    subTitle: 'When to send What',
    content: [
      'Name the campaign for you and your team.',
      'Select the Date and Time you want to send the campaign.',
      'Turn on or off the digital coupon. We recommend including a digital coupon whenever you provide a discount in a campaign. (Link to info on coupons.)',
      'If you want customers to claim an offer prior to assocaiting it with their account, turn this on. (Link to info about claiming.)',
      'What do you want the text message to say? Campaigns requiring claiming are limited to 135 characters. All other campaigns, are limited to 160 characters.',
    ],
  },
  {
    title: 'Who Gets it',
    subTitle: 'Who to send this to?',
    content: [
      'Send to all your customers',
      'or',
      'Selecting individual locations will send this campaign to only the customers of the selected locations.',
    ],
  },
  {
    title: 'The Offer',
    subTitle: 'The Carrot',
    content: [
      'Name the offer for you and your team.',
      'Customer display is shown on the tablet and online when the customer views this offer.',
      'Cashier directions is shown on the tablet to the cashiers to direct them how to redeem this offer for the customer.',
      'What dates do you want this offer valid for?',
    ],
  },
  {
    title: 'Confirmation Page',
    subTitle: 'Confirm the Campaign',
    content: [
      "Please confirm the details of the campaign and we'll get it ready to go out for you.",
    ],
  },
];



/** WEBPACK FOOTER **
 ** ./src/helpers/CampaignInfo.js
 **/